import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Row, Col, Button } from "reactstrap"
import { setClientModalData, setClientModalType, toggleClientModal } from '../../../../slices/modals/reducer';
import ClientTable from './ClientTable';
import ClientModal from './ClientModal';
import ClientDeleteModal from './ClientDeleteModal';
import { useLocation } from 'react-router-dom';
import { replace } from 'redux-first-history';
import { getAllBillings, getClientList } from '../../../../slices/auth/settings/thunk';
import { setInnerPreloader } from '../../../../slices/layouts/reducer';
import { getBillingSuccess, getClientSuccess } from '../../../../slices/auth/settings/reducer';
import checkPermission from '../../../../Components/Hooks/PermissionHook';
import { setBreadcrumb } from '../../../../slices/auth/menu/reducer';
import ClientActivateModal from './ClientActivateModal';

/**
 * React component for managing client-related functionality and rendering.
 * @component
 */
function Client() {
  const dispatch = useDispatch();
  const location = useLocation();

  const selectStates = createSelector(state => state, state => ({
    company: state.MenuData.client,
    previousLocations: state.router.previousLocations,
    title: state.MenuData.title
  }));
  const { company, previousLocations, title } = useSelector(selectStates);

  useEffect(() => {
    if (previousLocations[0].location.state === null && (previousLocations[0].action === "PUSH" || previousLocations[0].action === "POP") && company !== null) {
      dispatch(setInnerPreloader(true));
      dispatch(getClientList()).then(res => {
        dispatch(setBreadcrumb({ pageTitle: 'Settings', title: [{ name: 'Company Details', src: window.location.href }] }));
        dispatch(replace(location.pathname));
        dispatch(setInnerPreloader(false));
      });
    } else if (previousLocations[0].location.state !== null) {
      dispatch(getClientSuccess(previousLocations[0].location.state));
      dispatch(setBreadcrumb({ pageTitle: 'Settings', title: [{ name: 'Company Details', src: window.location.href }] }));
    }
  }, [location]);

  async function openClientModal() {
    dispatch(setClientModalType("add"));
    dispatch(setClientModalData(null));
    dispatch(getBillingSuccess([]));
    dispatch(getAllBillings());
    dispatch(toggleClientModal());
  }
  return (
    <div>
      <Row>
        <Col className="col-6">
          <div>

          </div>
        </Col>
        <Col className="col-6">
          <div className="d-flex justify-content-end">
            {checkPermission("companies", company._id, "companyDetailsCreate") ?
              <Button color="info" className="add-btn" id="create-btn" onClick={openClientModal}>
                <i className="ri-add-line align-bottom"></i> Add Client
              </Button>
              : null}
          </div>
        </Col>
      </Row>
      <ClientTable />
      <ClientModal />
      <ClientDeleteModal />
      <ClientActivateModal />
    </div>
  )
}

export default Client;
